// cache keys
export const viewTypeForCalendarKey = 'viewTypeForCalendar';
export const showRangeForCalendarKey = 'showRangeForCalendar';
export const durationForCalendarKey = 'durationForCalendar';
export const rulerStepForCalendarKey = 'rulerStepForCalendar';
export const intervalForCalendarKey = 'intervalForCalendar';
